<template>
  <div class="claim-type-step-item flex justify-center">
    <template v-if="hasClaimTypeStepItem">
      <div
        class="claim-type-step-item-title-content flex flex-col gap-3 w-full relative"
      >
        <div
          class="claim-type-step-item-required-switch-wrapper absolute gap-2 hidden"
        >
          <vs-switch
            class="claim-type-step-item-required-switch"
            v-model="mandatory"
            :color="AISEA_COLOR.BLUE"
          />
          <span>必須</span>
        </div>
        <div class="claim-type-step-item-header flex gap-5 mt-4 h-5">
          <div class="claim-type-step-item-header-title text-base font-normal">
            {{ claimItemTitle }}
            <span v-show="mandatory" class="required"> * </span>
          </div>
          <div
            class="claim-type-step-item-header-delete-btn ml-auto cursor-pointer hidden"
            @click="handleClickDelete"
          >
            <feather-icon
              :icon="'Trash2Icon'"
              class="p-0 inline-flex rounded-full h-5"
              :class="[{}]"
              :style="{}"
              svgClasses="h-5"
            ></feather-icon>
          </div>
          <div
            class="claim-type-step-item-header-question-btn cursor-pointer hidden"
            @click="handleClickQuestion(claimItem)"
          >
            <feather-icon
              :icon="'HelpCircleIcon'"
              class="p-0 inline-flex rounded-full mr-3 h-5"
              :class="[{}]"
              :style="{}"
              svgClasses="h-5"
            ></feather-icon>
          </div>
        </div>
        <div
          class="claim-type-step-item-drag-handle-wrapper cursor-pointer hidden absolute"
        >
          <div class="claim-type-step-item-drag-handle">
            <span class="material-icons">
              drag_indicator
            </span>
          </div>
        </div>
        <div class="claim-type-step-item-content">
          <claim-type-text-small v-if="claimItemInputType === 1" />
          <claim-type-text-area
            v-else-if="claimItemInputType === 2"
          ></claim-type-text-area>
          <common-drag v-else-if="claimItemInputType === 3"></common-drag>
          <claim-type-checkbox
            v-else-if="claimItemInputType === 4"
            :choices="claimItemChoices"
          ></claim-type-checkbox>
          <claim-type-select-box
            v-else-if="claimItemInputType === 5"
            :choices="claimItemChoices"
          ></claim-type-select-box>
          <claim-type-radio-buttons
            v-else-if="claimItemInputType === 6"
            :choices="claimItemChoices"
          ></claim-type-radio-buttons>
          <claim-type-contact
            v-else-if="claimItemInputType === 7"
          ></claim-type-contact>
          <claim-type-text-small
            v-else-if="claimItemInputType === 8"
          ></claim-type-text-small>
          <claim-type-text-box-date
            v-else-if="claimItemInputType === 9"
          ></claim-type-text-box-date>
          <claim-type-text-box-time
            v-else-if="claimItemInputType === 10"
          ></claim-type-text-box-time>
          <claim-type-text-lat-lon
            v-else-if="claimItemInputType === 11"
          ></claim-type-text-lat-lon>
          <claim-type-amount-of-money
            v-else-if="claimItemInputType === 12"
          ></claim-type-amount-of-money>
          <claim-type-unit
            v-else-if="claimItemInputType === 13"
          ></claim-type-unit>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CommonDrag from "../components/molecules/CommonDrag.vue";
import claimTemplateService from "@/services/claimTemplateService";
const ClaimTypeStepItem = claimTemplateService.getClaimTypeStepItemClass();
import isNull from "lodash/isNull";
import { ColorMixin } from "@/mixins";
import ClaimTypeTextSmall from "./ClaimTypeTextSmall.vue";
import ClaimTypeTextArea from "./ClaimTypeTextArea.vue";
import ClaimTypeCheckbox from "./ClaimTypeCheckbox.vue";
import ClaimTypeSelectBox from "./ClaimTypeSelectBox.vue";
import ClaimTypeRadioButtons from "./ClaimTypeRadioButtons.vue";
import ClaimTypeTextBoxTime from "./ClaimTypeTextBoxTime.vue";
import ClaimTypeTextBoxDate from "./ClaimTypeTextBoxDate.vue";
import ClaimTypeTextLatLon from "./ClaimTypeTextLatLon.vue";
import ClaimTypeAmountOfMoney from "./ClaimTypeAmountOfMoney.vue";
import ClaimTypeUnit from "./ClaimTypeUnit.vue";
import ClaimTypeContact from "./ClaimTypeContact.vue";

export default {
  name: "O.ClaimTypeFormStepItem",
  components: {
    CommonDrag,
    ClaimTypeTextSmall,
    ClaimTypeTextArea,
    ClaimTypeCheckbox,
    ClaimTypeSelectBox,
    ClaimTypeRadioButtons,
    ClaimTypeTextBoxTime,
    ClaimTypeTextBoxDate,
    ClaimTypeTextLatLon,
    ClaimTypeAmountOfMoney,
    ClaimTypeUnit,
    ClaimTypeContact,
  },
  mixins: [ColorMixin],
  props: {
    claimTypeStepItem: {
      type: ClaimTypeStepItem,
      required: true,
    },
    deleteClaimItem: {
      type: Function,
      required: true,
    },
    handleClickQuestion: {
      type: Function,
      required: true,
    },
    handleChangeMandatory: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mandatory: false,
    };
  },
  watch: {
    claimStepItemMandatory() {
      this.mandatory = this.claimStepItemMandatory;
    },
    mandatory() {
      this.handleChangeMandatory(this.mandatory);
    },
  },
  computed: {
    claimStepItemMandatory() {
      if (!this.claimTypeStepItem) return false;
      return this.claimTypeStepItem.mandatory;
    },
    hasClaimTypeStepItem() {
      return !isNull(this.claimTypeStepItem);
    },
    hasClaimItem() {
      return (
        this.hasClaimTypeStepItem && !isNull(this.claimTypeStepItem.claimItem)
      );
    },
    claimItem() {
      if (!this.hasClaimItem) return null;
      return this.claimTypeStepItem.claimItem;
    },
    claimItemTitle() {
      if (!this.hasClaimItem) return "";
      return this.claimItem.name;
    },
    claimItemInputType() {
      if (!this.hasClaimItem) return null;
      return this.claimItem.inputType;
    },
    claimItemChoices() {
      if (![4, 5, 6].includes(this.claimItemInputType)) return [];
      return this.claimItem.choices;
    },
  },
  methods: {
    handleClickDelete() {
      this.deleteClaimItem();
    },
  },
  created() {},
  mounted() {
    this.mandatory = this.claimStepItemMandatory;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.claim-type-step-item {
  min-height: 120px;
  &:hover {
    background-color: rgba(#039be5, 0.05);
    border: 1px solid #039be5;
    margin: -1px;
    .claim-type-step-item-header-delete-btn,
    .claim-type-step-item-header-question-btn,
    .claim-type-step-item-drag-handle-wrapper,
    .claim-type-step-item-required-switch-wrapper {
      display: flex;
      z-index: 1;
    }
    .claim-type-step-item-header-title,
    .claim-type-step-item-content {
      opacity: 0.3;
    }
  }
  .claim-type-step-item-required-switch-wrapper {
    top: 70px;
    right: 17px;
  }
  .claim-type-step-item-drag-handle-wrapper {
    top: 70px;
    left: 20px;
  }
  .required {
    color: $aisea-red;
  }
}
</style>
